import App from 'src/App.jsx';
import Root from 'src/Root';

// Same React render as the catch-all — the per-program planner OG metadata
// lives in sibling +data.ts / +title.ts / +description.ts / +image.ts /
// +Head.tsx. Without this Vike page the planner URL fell through to
// _catchall and emitted only generic site-level meta.
export default function Page() {
   return (
      <Root>
         <App />
      </Root>
   );
}
